module.exports = "<router-outlet></router-outlet>\r\n\r\n<app-info *ngIf=\"infoWinodowOpened\"></app-info>\r\n"